import './MyPetImages.scss';
import { PhotoGallerr } from '@/features/availability/components/PhotoGallerr';
type Props = {
    petImages?: any;
};


export const PetImages = ({ petImages }: Props) => {
  return (
    <div className="insurance-form tab-content">
      <div
        className={`insurance-top-section`}
      >
        <PhotoGallerr
            onChangeList={()=>{}}
            petsGalaryList={petImages}
            hideToggle={true}
          />
      </div>

    </div>
  );
};
